<template>
  <div>
    <v-text-field
      v-model="company.currency"
      :prefix="getCurrencySymbol()"
      readonly
      color="saPrimary"
      :label="$t('company.save.currency.title')"
    >
      <template v-slot:append>
        <v-tooltip top color="white">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-information-outline</v-icon>
          </template>
          <span
            class="greyDarken3--text body-1"
            v-html="
              $t('company.save.currency.tooltip') +
              $t('screener.admin.company.monetization.currency.tooltip')
            "
          ></span>
        </v-tooltip>
      </template>
    </v-text-field>
    <!-- Revenue calculation time in hours -->
    <v-text-field
      v-model="company.custom_properties.revenue_calculation_time"
      color="saPrimary"
      :label="
        $t('screener.admin.company.registration.revenue_calculation_time')
      "
      :rules="[
        rules.required,
        rules.numeric,
        rules.inBetween(
          48,
          72,
          company.custom_properties.revenue_calculation_time
        ),
      ]"
    >
      <template v-slot:append>
        <v-tooltip top color="white">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-information-outline</v-icon>
          </template>
          <span
            class="greyDarken3--text body-1"
            v-html="
              $t(
                'screener.admin.company.registration.revenue_calculation_time.tooltip'
              )
            "
          ></span>
        </v-tooltip>
      </template>
    </v-text-field>
    <!-- Commission percentage -->
    <v-text-field
      id="reduced_price_commission_percentage"
      :label="$t('screener.admin.company.reduced_price_commission_percentage.title')"
      name="reduced_price_commission_percentage"
      type="text"
      :rules="[rules.inBetween(0, 100, company.reduced_price_commission_percentage)]"
      v-model="company.reduced_price_commission_percentage"
      color="saPrimary"
    >
      <template v-slot:append>
        <v-tooltip top color="white">
          <template v-slot:activator="{on}">
            <v-icon v-on="on">mdi-information-outline</v-icon>
          </template>
          <div class="greyDarken3--text body-1">
            {{ $t('screener.admin.company.reduced_price_commission_percentage.tooltip') }}
          </div>
        </v-tooltip>
      </template></v-text-field
    >
  </div>
</template>

<script>
import rules from "@/validation";
import { getCurrencySymbol } from "@/helper";

export default {
  name: "AdminCompanyProfileMonetization",
  props: {
    company: {
      type: Object,
      default: null,
    },
  },
  data() {
    return { rules };
  },
  watch: {
    company: {
      handler: function () {
        this.$emit("update:company", this.company);
      },
      deep: true,
    },
  },
  methods: {
    getCurrencySymbol() {
      return getCurrencySymbol(this.currency);
    },
  },
};
</script>

<style>
</style>
